import React, { useState } from 'react';
import { Star } from 'lucide-react';
import './StarRating.css';

const SIZES = {
  small:  { star: 14 },
  medium: { star: 18 },
  large:  { star: 28 },
};

const RATING_LABELS = ['', 'Poor', 'Fair', 'Good', 'Very good', 'Excellent'];

export default function StarRating({
  value = 0,
  onChange,
  size = 'medium',
  readonly = false,
  showValue = false,
}) {
  const [hovered, setHovered] = useState(0);
  const { star: starSize } = SIZES[size] || SIZES.medium;

  if (readonly) {
    const rounded = Math.round(value * 2) / 2;
    return (
      <div className={`star-rating star-rating--${size}`}>
        {[1, 2, 3, 4, 5].map((i) => {
          const isFull = i <= Math.floor(rounded);
          const isHalf = !isFull && i === Math.ceil(rounded) && rounded % 1 !== 0;
          return (
            <span key={i} className="star-rating__star">
              {isFull && <Star size={starSize} fill="#7C3AED" stroke="#7C3AED" strokeWidth={1.5} />}
              {isHalf && (
                <span className="star-rating__half" style={{ width: starSize, height: starSize }}>
                  <Star size={starSize} fill="none" stroke="#D1D5DB" strokeWidth={1.5} />
                  <span className="star-rating__half-fill">
                    <Star size={starSize} fill="#7C3AED" stroke="#7C3AED" strokeWidth={1.5} />
                  </span>
                </span>
              )}
              {!isFull && !isHalf && <Star size={starSize} fill="none" stroke="#D1D5DB" strokeWidth={1.5} />}
            </span>
          );
        })}
        {showValue && value > 0 && (
          <span className="star-rating__value">{Number(value).toFixed(1)}</span>
        )}
      </div>
    );
  }

  const display = hovered || value;

  return (
    <div
      className={`star-rating star-rating--${size} star-rating--interactive`}
      onMouseLeave={() => setHovered(0)}
    >
      {[1, 2, 3, 4, 5].map((i) => (
        <button
          key={i}
          type="button"
          className={`star-rating__btn${i <= display ? ' star-rating__btn--active' : ''}`}
          onMouseEnter={() => setHovered(i)}
          onClick={() => onChange?.(i)}
          aria-label={`Rate ${i} star${i !== 1 ? 's' : ''}`}
        >
          <Star
            size={starSize}
            fill={i <= display ? '#7C3AED' : 'none'}
            stroke={i <= display ? '#7C3AED' : '#D1D5DB'}
            strokeWidth={1.5}
          />
        </button>
      ))}
      {hovered > 0 && (
        <span className="star-rating__label">{RATING_LABELS[hovered]}</span>
      )}
    </div>
  );
}
